export default __webpack_public_path__ + "static/media/miguel-lopes-26.84ca8e3c.jpg";